(function () {
  // TODO: Replace these with your real Shopify Product IDs
  // You can find the Product ID in the Shopify Admin product URL.
  // Example: /admin/products/1234567890  -> 1234567890
  var ELIGIBLE_PRODUCT_IDS = [
    8724879573166  // All Purpose Starter Pack
  ];

  // Fixed discounts in cents
  var PROMO_DISCOUNTS = {
    TRYCLEAN: 1401,
    TRYBETTER: 1901,
    TRYSAFE: 1200
  };

  var PROMO_MESSAGES = {
    TRYCLEAN: "Special price: powerful clean, no harsh fumes, makes up to 4 bottles.",
    TRYBETTER: "Special price: powerful clean, no harsh fumes, makes up to 4 bottles.",
    TRYSAFE: "Special price: powerful clean, no harsh fumes, makes up to 4 bottles."
  };

  function formatMoneyFromCents(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function getCurrentDisplayedPriceCents() {
    var el =
      document.querySelector(".price .price-item--regular") ||
      document.querySelector(".price .price-item--sale") ||
      document.querySelector(".price .price-item");

    if (!el) return null;

    var txt = (el.textContent || "").replace(/[^0-9.]/g, "");
    if (!txt) return null;

    var dollars = parseFloat(txt);
    if (isNaN(dollars)) return null;

    return Math.round(dollars * 100);
  }

  function isEligibleProduct() {
    if (!window.BTC_PRODUCT || window.BTC_PRODUCT.id == null) return false;

    var id = Number(window.BTC_PRODUCT.id);
    if (!id) return false;

    return ELIGIBLE_PRODUCT_IDS.includes(id);
  }

  function applyPromoPriceDisplay() {
    var eligible = isEligibleProduct();

    if (eligible) {
      document.documentElement.classList.add("btc-promo-eligible");
    } else {
      document.documentElement.classList.remove("btc-promo-eligible");
    }

    if (!window.BTC_PROMO) return;

    var promoCode = String(window.BTC_PROMO).toUpperCase();
    var discountCents = PROMO_DISCOUNTS[promoCode];
    if (!discountCents) return;

    if (!eligible) return;

    var promoWrap = document.querySelector(".btc-promo-price");
    if (!promoWrap) return;

    var wasEl = promoWrap.querySelector(".btc-was-value");
    var nowEl = promoWrap.querySelector(".btc-now-value");
    if (!wasEl || !nowEl) return;

    var noteEl = promoWrap.querySelector(".btc-promo-note");

    var wasCents = getCurrentDisplayedPriceCents();
    if (wasCents == null) return;

    var nowCents = Math.max(wasCents - discountCents, 0);

    wasEl.textContent = formatMoneyFromCents(wasCents);
    nowEl.textContent = formatMoneyFromCents(nowCents);

    if (noteEl) {
      noteEl.textContent = PROMO_MESSAGES[promoCode] || "";
    }
    promoWrap.style.display = "block";
  }

  document.addEventListener("DOMContentLoaded", applyPromoPriceDisplay);

  // Dawn triggers variant:change on product pages
  document.addEventListener("variant:change", applyPromoPriceDisplay);
})();